import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const attributeParser = /*           */ asExport(
  o_util,
  "attributeParser",
  {}
);
const parseParameters = /*           */ asExport(
  attributeParser,
  "parseParameters",
  noop
);
const parseAttributeName = /*           */ asExport(
  attributeParser,
  "parseAttributeName",
  noop
);
const mergeParameterValues = /*           */ asExport(attributeParser, "mergeParameterValues", noop);
export {
  attributeParser,
  mergeParameterValues,
  parseAttributeName,
  parseParameters
};
/*                                                */
